// extracted by mini-css-extract-plugin
export default {"tableBox":"TableBox_tableBox__L+Fsf","loaderContainer":"TableBox_loaderContainer__hVATA"};